import { database, dbViews } from 'lib_ui-services';

// Wrap the lib_ui-services deps as own functions so they stay injectable in unit tests
// (the imported `dbViews` is a read-only ES module namespace and cannot be spied on directly).
const _p = {
    getDatabase: () => database.get(),
    refreshViewsForRelation: (namespaceTitle, relationTitle) =>
        dbViews.refreshViewsForRelation(namespaceTitle, relationTitle)
};
export const _private = _p;

/**
 * Shared save-success handler for the Serialized-Each create bridges — "Create With Auto
 * Serialization" (`transaction:itemsByModel`) and "Create From RFID Tag" (`transaction:itemByTagId`).
 * Both render as an item:item DetailPane hosting a SingleRecordForm on a virtual transaction relation;
 * on save the server bridge fans the POST out into real `item:item` assets that arrive via socket
 * notifications.
 *
 * Two things happen here:
 *  1. Collapse the host pane by clearing the item:item ActiveRecord ('cancel', type 'ignore-changes'
 *     to skip the unsaved-changes prompt — the inner SingleRecordForm re-initializes immediately).
 *  2. Reveal the generated assets. The item:item grid applies the #332 limitSyncSize display gate,
 *     which pins the grid to the last server page and hides socket-delivered rows until a filter
 *     change. The Path-2 UI import resets that gate via didCreate_import_import, but these POST
 *     bridges have no equivalent client hook — so freshly created assets stayed hidden until a manual
 *     sync/reload. Mirror the Path-2 refresh: pull item:item, then reset the gate. The server bridges
 *     create the assets in an AWAITED prerequisite (see the rules-engine didCreate_transaction_*),
 *     so they already exist server-side when this runs — the sync is deterministic, not racy.
 *
 * Step 1 is immediate; step 2 is best-effort and must never surface as an error after the save has
 * already succeeded.
 *
 * @param {{ dispatch: Function, log?: { warn?: Function } }} params
 */
export default async function closePaneAndRevealAssets({ dispatch, log }) {
    dispatch(
        {},
        {
            verb: 'cancel',
            namespace: 'item',
            relation: 'item',
            type: 'ignore-changes'
        }
    );

    try {
        const syncPromise = _p.getDatabase()?.synchronization?.syncOneRelation({
            namespaceTitle: 'item',
            relationTitle: 'item'
        });
        if (syncPromise) {
            await syncPromise.catch(err => log?.warn?.('SE reveal: post-create item sync failed', err));
        }
    } catch (err) {
        log?.warn?.('SE reveal: post-create item sync skipped', err);
    }

    try {
        await _p.refreshViewsForRelation('item', 'item');
    } catch (err) {
        log?.warn?.('SE reveal: item view refresh failed', err);
    }
}
